var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isPermission)?_c('div',[_c('view-analytics-header'),_c('div',{class:{
            'layout-analytics__container': _vm.$route.name !== 'analyticsSummary',
            'layout-analytics-summary__container' : _vm.$route.name === 'analyticsSummary'
        }},[_c('router-view')],1)],1):_c('div',[_vm._v("\n    У вас нет прав на доступ к рабочему столу\n")])}
var staticRenderFns = []

export { render, staticRenderFns }